import { useEffect, useState } from "react";
import { supabase } from "../lib/supabaseClient";

export default function ResearchOAuthConsentPage() {
  const authorizationId = new URLSearchParams(window.location.search).get("authorization_id");
  const [details, setDetails] = useState(null);
  const [error, setError] = useState("");
  const [busy, setBusy] = useState(false);
  const [done, setDone] = useState(false);
  useEffect(() => {
    let active = true;
    if (!/^[a-zA-Z0-9_-]{8,256}$/.test(authorizationId || "") || !supabase?.auth?.oauth) {
      return undefined;
    }
    supabase.auth.oauth.getAuthorizationDetails(authorizationId).then(({ data, error: failure }) => {
      if (!active) return;
      if (failure || data?.authorization_id !== authorizationId || !data?.client?.name) {
        setError("Die Anfrage ist ungültig, abgelaufen oder wurde bereits freigegeben. Bitte im Assistenten erneut verbinden.");
      } else {
        setDetails(data);
      }
    }).catch(() => { if (active) setError("Die Freigabeanfrage konnte nicht geprüft werden."); });
    return () => { active = false; };
  }, [authorizationId]);

  async function decide(approved) {
    if (!details || busy || done) return;
    setBusy(true); setError("");
    try {
      const action = approved ? "approveAuthorization" : "denyAuthorization";
      const { data, error: failure } = await supabase.auth.oauth[action](authorizationId, { skipBrowserRedirect: true });
      if (failure) throw new Error("CONSENT_FAILED");
      setDone(true);
      if (data?.redirect_url) {
        const redirect = new URL(data.redirect_url);
        if (redirect.protocol !== "https:" || redirect.username || redirect.password) throw new Error("INVALID_REDIRECT");
        window.location.assign(redirect.href);
      }
    } catch {
      setError("Die Entscheidung konnte nicht abgeschlossen werden. Bitte im Assistenten erneut verbinden.");
    } finally { setBusy(false); }
  }
  const invalid = !/^[a-zA-Z0-9_-]{8,256}$/.test(authorizationId || "") || !supabase?.auth?.oauth;
  return <main className="flex min-h-screen items-center justify-center bg-[#020711] p-6 text-slate-100">
    <section className="w-full max-w-xl rounded-2xl border border-slate-700 bg-[#07111f] p-8" aria-label="HQS Datenzugang freigeben">
      <h1 className="text-2xl font-bold">HQS Datenzugang freigeben</h1>
      <p className="my-4 text-slate-300">Du bist als HQS Owner angemeldet. Prüfe die anfragende Anwendung, bevor du den Zugriff bestätigst.</p>
      {invalid && <p role="alert">Keine gültige Freigabeanfrage vorhanden.</p>}
      {error && <p role="alert">{error}</p>}
      {!invalid && !details && !error && <p role="status">Anfrage wird geprüft …</p>}
      {details && <>
        <dl className="my-5 space-y-3"><div><dt>Anwendung</dt><dd>{details.client.name}</dd></div>
          <div><dt>Registrierte Rückleitung</dt><dd className="break-all">{details.redirect_uri}</dd></div>
          <div><dt>Angefragte Anmeldung</dt><dd>{details.scope || "Anmeldung"}</dd></div></dl>
        <p className="mb-5 text-slate-300">Freigegebene ChatGPT- und Claude-Clients können HQS Forschungsdaten und archivierte Datenpakete lesen. Jede Anwendung braucht eine eigene Freigabe. Handelsausführung und Regeländerungen sind über diesen Zugang gesperrt.</p>
        <div className="flex gap-3"><button type="button" disabled={busy || done} onClick={() => void decide(true)} className="min-h-11 rounded-lg bg-cyan-200 px-4 font-semibold text-slate-950">Lesenden Zugriff erlauben</button>
          <button type="button" disabled={busy || done} onClick={() => void decide(false)} className="min-h-11 rounded-lg border border-slate-500 px-4">Ablehnen</button></div>
      </>}
      {done && <p role="status" className="mt-5">Entscheidung gespeichert. Kehre zur anfragenden Anwendung zurück.</p>}
    </section>
  </main>;
}
